import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StyleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"style"}/>
}
